import { render } from "./PublishPage.vue?vue&type=template&id=0e9dedd6&scoped=true"
import script from "./PublishPage.vue?vue&type=script&lang=js"
export * from "./PublishPage.vue?vue&type=script&lang=js"

import "./PublishPage.vue?vue&type=style&index=0&id=0e9dedd6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e9dedd6"]])

export default __exports__